module.exports = __webpack_public_path__ + "img/0.73b0f9c6.jpg";